import React from "react"

/**
 * @type {React.FC<React.HTMLAttributes<SVGElement>>}
 */
export const CalendarIcon = props => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.33325 1.33301V3.99967"
      stroke="#222020"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6667 1.33301V3.99967"
      stroke="#222020"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6667 2.66699H3.33333C2.59695 2.66699 2 3.26395 2 4.00033V13.3337C2 14.07 2.59695 14.667 3.33333 14.667H12.6667C13.403 14.667 14 14.07 14 13.3337V4.00033C14 3.26395 13.403 2.66699 12.6667 2.66699Z"
      stroke="#222020"
      strokeWidth="1.12"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 6.66699H14"
      stroke="#222020"
      strokeWidth="1.12"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
